import React from "react";
import Gridone from "./gridone";
import Gridtwo from "./gridtwo";
const Grids = () => {
  return (
    <div>
      <Gridtwo />
      <Gridone />
    </div>
  );
};

export default Grids;
